// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"account":"1786f6f3","administration":"8746c727"}[chunkId] + ".chunk.js";
};